/** Platform-neutral lifecycle. No external SDK, tracking, accounts or ads on the open web. */
export type PlatformEvent = 'loadingStart' | 'loadingStop' | 'gameplayStart' | 'gameplayStop'
export interface PlatformAdapter {
  loadingStart(): void
  loadingStop(): void
  gameplayStart(): void
  gameplayStop(): void
}
type SDK = { game?: Partial<PlatformAdapter> }
let loading = false
let playing = false
let adapter: PlatformAdapter | undefined
function emit(type: PlatformEvent): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent('mecharulez:platform', { detail: { type, version: 1 } }))
  try { adapter?.[type]() } catch (error) { console.warn('Platform lifecycle event failed', type, error) }
}
export function installPlatformAdapter(next: PlatformAdapter): void {
  adapter = next
  if (loading) next.loadingStart()
  if (playing) next.gameplayStart()
}
/** Called only by the later platform integration after its SDK has initialized. */
export function crazyGamesAdapter(sdk: SDK): PlatformAdapter {
  return {
    loadingStart: () => sdk.game?.loadingStart?.(), loadingStop: () => sdk.game?.loadingStop?.(),
    gameplayStart: () => sdk.game?.gameplayStart?.(), gameplayStop: () => sdk.game?.gameplayStop?.(),
  }
}
export const platform: PlatformAdapter = {
  loadingStart() { if (!loading) { loading = true; emit('loadingStart') } },
  loadingStop() { if (loading) { loading = false; emit('loadingStop') } },
  gameplayStart() { if (!playing) { playing = true; emit('gameplayStart') } },
  gameplayStop() { if (playing) { playing = false; emit('gameplayStop') } },
}
